var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"MusicExam"},[_vm._v(" 音乐考级 "),_c('footerTabber')],1)}
var staticRenderFns = []

export { render, staticRenderFns }